import { notify } from 'utils/reduxUtils';

export const types = {
  CHECKOUT_SETTINGS_FETCH_SUCCESS:
    'settings/digiQuote/CHECKOUT_SETTINGS_FETCH_SUCCESS',
  CHECKOUT_SETTINGS_FETCH_ERROR:
    'settings/digiQuote/CHECKOUT_SETTINGS_FETCH_ERROR',
  CHECKOUT_SETTINGS_UPDATE_ERROR:
    'settings/digiQuote/CHECKOUT_SETTINGS_UPDATE_ERROR',
  CHECKOUT_SETTINGS_UPDATE_REQUEST:
    'settings/digiQuote/CHECKOUT_SETTINGS_UPDATE_REQUEST',
  CHECKOUT_SETTINGS_UPDATE_SUCCESS:
    'settings/digiQuote/CHECKOUT_SETTINGS_UPDATE_SUCCESS',
};

export const fetchCheckoutSettings = {
  success: ({ allowLocalPickup, sendOrderConfirmationEmails }) => ({
    type: types.CHECKOUT_SETTINGS_FETCH_SUCCESS,
    payload: { allowLocalPickup, sendOrderConfirmationEmails },
  }),
  error: notify((error) => ({
    type: types.CHECKOUT_SETTINGS_FETCH_ERROR,
    payload: error,
  })),
};

export const updateCheckoutSettings = {
  request: ({ allowLocalPickup, sendOrderConfirmationEmails }) => ({
    type: types.CHECKOUT_SETTINGS_UPDATE_REQUEST,
    payload: { allowLocalPickup, sendOrderConfirmationEmails },
  }),
  success: notify(
    ({ allowLocalPickup, sendOrderConfirmationEmails }) => ({
      type: types.CHECKOUT_SETTINGS_UPDATE_SUCCESS,
      payload: { allowLocalPickup, sendOrderConfirmationEmails },
    }),
    'Checkout settings updated',
  ),
  error: notify(
    (error) => ({
      type: types.CHECKOUT_SETTINGS_UPDATE_ERROR,
      payload: error,
    }),
    'Can`t update checkout settings',
  ),
};
